import { render, staticRenderFns } from "./AdminPanelButton.vue?vue&type=template&id=58332e00&scoped=true"
import script from "./AdminPanelButton.vue?vue&type=script&lang=js"
export * from "./AdminPanelButton.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelButton.vue?vue&type=style&index=0&id=58332e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58332e00",
  null
  
)

export default component.exports